import { useState, useEffect } from "react";

const useItemsPerPage = (
  initialItemsPerPage: number,
  mediumScreenItemsPerPage: number,
  largeScreenItemsPerPage: number,
  thresholdMedium: number,
  thresholdLarge: number,
  giantScreenItemsPerPage?: number,
  thresholdGiant?: number
) => {
  const [itemsPerPage, setItemsPerPage] = useState(initialItemsPerPage);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width < thresholdMedium) {
        setItemsPerPage(initialItemsPerPage);
      } else if (width >= thresholdMedium && width < thresholdLarge) {
        setItemsPerPage(mediumScreenItemsPerPage);
      } else if (
        thresholdGiant &&
        giantScreenItemsPerPage &&
        width >= thresholdGiant
      ) {
        setItemsPerPage(giantScreenItemsPerPage);
      } else {
        setItemsPerPage(largeScreenItemsPerPage);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [
    initialItemsPerPage,
    mediumScreenItemsPerPage,
    largeScreenItemsPerPage,
    thresholdMedium,
    thresholdLarge,
    giantScreenItemsPerPage,
    thresholdGiant,
  ]);

  return itemsPerPage;
};

export default useItemsPerPage;
